export interface siteInteface {
	siteName: string;
	siteLogoMenu: any;
	siteLogoFooter: any;
	siteDefaultName: string;
	siteAbout?: string;
	lojas: lojaInterface[];
}

export interface lojaInterface {
	nome: string;
	telefone?: string;
	telefoneService?: string;
	email?: string;
	endereço: string;
	hShow?: string;
	hService?: string;
	hPosVenda?: string;
	hPecas?: string;
}

export const LOJAS_DATA: lojaInterface[] = [
	{
		nome: "SIA",
		telefone: "(61) 2103-5900",
		email: "SIA@toyotakyoto.com.br",
		endereço:
			"Endereço: SIA TRECHO 1 LOTES 1160,1170,1180,1190,1200,1210, SN, Bairro: ZONA INDUSTRIAL GUARÁ, CEP: 71.200-012",
		hShow: "Dias úteis: de 08h às 18h ,Sábados: 08h às 16h",
		hService: "Dias úteis 07:30h às 18h ,SÁBADO: 08h ás 12h",
		hPecas: "Dias úteis: 08h às 18h ,SÁBADO: 08h às 12h",
	},
	{
		nome: "TAGUATINGA",
		telefone: "(61) 3772-6800",
		telefoneService: "(61) 99624-0601",
		email: "Taguatinga@toyotakyoto.com.br",
		endereço: "QS 3 RUA 452 LOTE 01, S/N, águas Claras, Brasília,71953-000",
		hShow: "Dias úteis: de 08h às 18h ,Sábados: 08h às 16h",
		hService: "Dias úteis: 07:30h às 18h ,SÁBADO: 08h às 12h",
		hPecas: "Dias úteisde 08h às 18h ,SÁBADO: 08h às 12h",
	},
	{
		nome: "EPIA SUL",
		telefone: "(61) 2108-7878",
		email: "epiasul@toyotakyoto.com.br",
		endereço: "SPMS s/n, DF-003 - Núcleo Bandeirante, Brasília - DF",
		hShow: "Dias úteis de 08h às 18h ,Sábados: 08h às 16h",
		hService: "Dias úteis: 07:30h às 18h ,SÁBADO: 08h às 12h",
		hPecas: "Dias úteis: de 08h às 18h ,SÁBADO: 08h às 12h(Plantão)",
	},
	{
		nome: "AEROPORTO",
		telefone: "(61) 2017-7600",
		endereço:
			"Aeroporto Internacional de Brasília - Presidente Juscelino Kubitschek - Lote UC 4079 - Lago Sul, Brasília - DF, 71608-900",
		hShow: "Dias úteis de 08h às 18h ,Sábados: 08h às 16h",
		hService: "Seg a sex: 08h às 18h ,Sáb: 08h às 12h",
		hPosVenda: "Seg a sex: 08h às 18h ,Sáb: 08h às 12h",
	},
];

export const SITES_CONFIG = {
	KURUMA: {
		siteName: "KYOTO",
		siteDefaultName: "Kyoto",
		lojas: LOJAS_DATA,
		pathname: typeof window !== "undefined" ? window.location.pathname : "",
	},
} as const;

export const actualSite = () => {
	const siteName = process.env
		.NEXT_PUBLIC_SITE_NAME as keyof typeof SITES_CONFIG;
	return SITES_CONFIG[siteName] || SITES_CONFIG.KURUMA;
};

export function formatCarModel(model: string): string {
	return model
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

export function formatName(model: string): string {
	return model
		.toLocaleLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

export const BRAND_NAMES = {
	SEMINOVOS_SITE_URL: "https://www.kyotoseminovos.com.br",
	SEMINOVOS_CERTIFICADO_URL:
		"https://www.kyotoseminovos.com.br/veiculos?certificado=true&ano=2018,2025&preco=4390000,42499000&km=101,81193&entrada=12749700&ordenacao=1",
	CHAT_INSTANCE_ID: "SITE_KYOTO",
	CHAT_API_KEY: "A3C8F9B14D6E2A579C823FB745D1E6ABA3C8F9B14D6E2A57",
	POS_NUMBER: "556130032626",
	NORMAL_NUMBER: "556199870056",
	WHATSAPP_NOVOS_MESSAGE:
		"Olá! Quero saber mais sobre as ofertas de veículos novos da Toyota",
	STATE: "Brasília",
	STATE_RED: "em Brasília",
	SUB_BRAND: "9",
	DEFAULT: "Kyoto",
	UPPERCASE: "KYOTO",
	LOWERCASE: "kyoto",
	LOWERCASE_PLAIN: "kyoto",
	ALL_CAPS: "KYOTO",
	CAMELCASE: "Kyoto",
	DISPLAY: "Kyoto Veículos",
	LEGAL: "Kyoto Veículos Toyota",
	SHORT: "KTO",
	URL: "toyotakyoto",
	META_TITLE: "Kyoto Toyota",
	EMAIL_DOMAIN: "@kyotoveiculos.com.br",
	NUMERO_POS_VENDA: "6130032626",
	NUMERO_POS_VENDA_TRATADO: "(61) 3003-2626",
	siteLogoMenu:
		"https://sablobsitestoyotaprd.blob.core.windows.net/images/logo_menu_kyoto.svg",
	ABOUT: `A Kyoto Toyota é parte do Grupo Águia Branca, um dos maiores e mais respeitados conglomerados de transporte e logística do Brasil, com sede no Espírito Santo. Em Brasília, contamos com três concessionárias estrategicamente localizadas no SIA, Epia Sul e Taguatinga, oferecendo aos clientes uma experiência Toyota de excelência e confiança.

Desde 1946, o Grupo Águia Branca tem se destacado em todo o Brasil, atuando nos setores de transporte de passageiros, logística, transporte de cargas, aluguel de veículos, terceirização de frotas e comércio de veículos. Com presença nacional e mais de 100 concessionárias, o grupo é o maior representante da Toyota na América Latina e o maior grupo de concessionárias Lexus no Brasil, apoiado por uma equipe de mais de 20 mil colaboradores certificados pela GPTW, movidos pela paixão de oferecer o melhor em todas as nossas operações.

As concessionárias Toyota do Grupo Águia Branca seguem rigorosamente os padrões globais da montadora, com o propósito de proporcionar aos nossos clientes uma experiência de compra e posse inigualável no mercado automotivo. Há mais de 78 anos, o Grupo Águia Branca tem sido sinônimo de excelência, inovação e expansão contínua.

Como representantes da Toyota em três estados — Distrito Federal, Minas Gerais e Espírito Santo —, temos orgulho de honrar diariamente o compromisso com a qualidade e confiabilidade, valores que definem a Toyota mundialmente. Nossa jornada é impulsionada pela paixão em conectar pessoas e oportunidades, sempre oferecendo produtos e serviços de excelência.`,
} as const;

// Tipo utilitário para acessar as chaves
export type BrandNameKeys = keyof typeof BRAND_NAMES;
